module.exports = __webpack_public_path__ + "static/img/act-detail-share.6b166f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/act-detail-share.png
// module id = fpRP
// module chunks = 3